import type { CSSProperties, ReactElement } from "react";
import { Cmarkdownvisual, CmarkdownvisualType } from "../Cmarkdownvisual";
import { KanbanBoard } from "./KanbanBoard";
import { KanbanScrollFades } from "./KanbanScrollFades";
import type { CmarkdownkanbanController } from "./useCmarkdownkanbanController";
import {
  CONTAINER_BOTTOM_PADDING,
  CONTAINER_HORIZONTAL_PADDING,
  CONTAINER_TOP_PADDING,
  KANBAN_METRIC_UNIT,
} from "./kanban-view-constants";

interface CmarkdownkanbanViewProps {
  controller: CmarkdownkanbanController;
  className?: string;
  style?: CSSProperties;
}

export function CmarkdownkanbanView({
  controller,
  className,
  style,
}: CmarkdownkanbanViewProps): ReactElement {
  return (
    <Cmarkdownvisual
      dataElScope="Cmarkdownkanban/CmarkdownkanbanView"
      type={CmarkdownvisualType.Kanban}
      controls={controller.controls}
      modalControls={controller.controls}
      contentStyle={{
        padding: `${CONTAINER_TOP_PADDING} ${CONTAINER_HORIZONTAL_PADDING} ${CONTAINER_BOTTOM_PADDING} ${CONTAINER_HORIZONTAL_PADDING}`,
        position: "relative",
        flex: 1,
        minHeight: 0,
      }}
      className={className}
      compactPreview={controller.compactPreview}
      metric={{ value: controller.totalCards, unit: KANBAN_METRIC_UNIT }}
      style={style}
    >
      <KanbanBoard
        parsed={controller.parsed}
        scrollContainerRef={controller.scrollContainerRef}
        activeHoveredCardKey={controller.activeHoveredCardKey}
        setColumnRef={controller.setColumnRef}
        onHoverCard={controller.onHoverCard}
        clearHoveredCard={controller.clearHoveredCard}
      />

      <KanbanScrollFades scrollHintState={controller.scrollHintState} />
    </Cmarkdownvisual>
  );
}
